export default[
    {
        path: '/dataList/integralAchievement',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '积分业绩',
            authLogin: true
        }
    }
]